import React from 'react';

import { TIconType } from '../interface';

const ConsistencyIconActive: TIconType = () => {
	return (
		<svg
			fill='none'
			height='21'
			viewBox='0 0 18 21'
			width='18'
		>
			<path
				d='M15.75 2.00034H12.3469C11.9265 1.52816 11.4109 1.15029 10.8341 0.891542C10.2573 0.632793 9.63221 0.499023 9 0.499023C8.36779 0.499023 7.74274 0.632793 7.16591 0.891542C6.58908 1.15029 6.07353 1.52816 5.65313 2.00034H2.25C1.85218 2.00034 1.47064 2.15837 1.18934 2.43968C0.908035 2.72098 0.75 3.10251 0.75 3.50034V19.2503C0.75 19.6482 0.908035 20.0297 1.18934 20.311C1.47064 20.5923 1.85218 20.7503 2.25 20.7503H15.75C16.1478 20.7503 16.5294 20.5923 16.8107 20.311C17.092 20.0297 17.25 19.6482 17.25 19.2503V3.50034C17.25 3.10251 17.092 2.72098 16.8107 2.43968C16.5294 2.15837 16.1478 2.00034 15.75 2.00034ZM9 2.00034C9.79489 2.00281 10.5565 2.31967 11.1186 2.88175C11.6807 3.44382 11.9975 4.20545 12 5.00034H6C6.00247 4.20545 6.31934 3.44382 6.88141 2.88175C7.44349 2.31967 8.20511 2.00281 9 2.00034ZM12 14.0003H6C5.80109 14.0003 5.61032 13.9213 5.46967 13.7807C5.32902 13.64 5.25 13.4492 5.25 13.2503C5.25 13.0514 5.32902 12.8607 5.46967 12.72C5.61032 12.5794 5.80109 12.5003 6 12.5003H12C12.1989 12.5003 12.3897 12.5794 12.5303 12.72C12.671 12.8607 12.75 13.0514 12.75 13.2503C12.75 13.4492 12.671 13.64 12.5303 13.7807C12.3897 13.9213 12.1989 14.0003 12 14.0003ZM12 11.0003H6C5.80109 11.0003 5.61032 10.9213 5.46967 10.7807C5.32902 10.64 5.25 10.4492 5.25 10.2503C5.25 10.0514 5.32902 9.86066 5.46967 9.72001C5.61032 9.57935 5.80109 9.50034 6 9.50034H12C12.1989 9.50034 12.3897 9.57935 12.5303 9.72001C12.671 9.86066 12.75 10.0514 12.75 10.2503C12.75 10.4492 12.671 10.64 12.5303 10.7807C12.3897 10.9213 12.1989 11.0003 12 11.0003Z'
				fill='white'
			/>
		</svg>
	);
};

export default ConsistencyIconActive;
